module.exports = __webpack_public_path__ + "static/media/video-watch-taggis.4f373ca4.jpg";